'use strict'
import {onFind} from "../libs/@elements/init-modules-in-scope";
import initModulesInScope from '../libs/@elements/init-modules-in-scope';
import {removeAttribute, on, closest, addClass, setAttribute, find, findIn} from "../libs/@elements/dom-utils";
import { showNotification } from "../libs/@elements/alert-notification";
import throwError from "../libs/@elements/throw-error";
import {translate} from "../../shared/translations/translations";
import formDataEntries from 'form-data-entries';
import fetch from "../libs/@elements/fetch";
import {createFormValidation} from "./form-validation";
import Modal from 'bootstrap/js/dist/modal';
import 'url-search-params-polyfill'; // Edge Polyfill

let pendingRequest;

export function init() {
    let modalBody = find('.js-ajax-address__body');
    let loading = find('.js-ajax-address__loading');

    onFind('.js-ajax-address__link', function (button) {

        on('click', function (e) {
            let adressItem = document.getElementsByClassName('js-ajax-address');
            let activeAdressItem = closest('.js-ajax-address', this);
            for (let i = 0; i < adressItem.length; i++) {
                adressItem[i].classList.remove('js-ajax-address--active');
            }

            addClass('js-ajax-address--active', activeAdressItem);

            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            e.preventDefault();

            let url = this.getAttribute('data-href') || throwError(translate('no.action.url'))

            removeAttribute('hidden', loading);

            pendingRequest = fetch(url, {
                method: 'POST',
                dataType: 'JSON'
            });
            pendingRequest
                .then((response) => {
                    return response.clone().json()
                }).then((response) => {

                if (response.success) {
                    let html = response.html || throwError(translate('no.html.given'))
                    modalBody.innerHTML = html;
                    setAttribute('hidden', true, loading);
                    addressForm(modalBody);
                    initModulesInScope(modalBody);
                }
            }).catch((error) => {
                if (error.name !== 'AbortError') {
                    /*Do error stuff*/
                    console.error(error);
                }
                setAttribute('hidden', true, loading);
            });
            showNotification(pendingRequest);
        }, button)
    });

    function addressForm(){
        let modalForm = find('.js-ajax-address__form');
        let activeAddress = find('.js-ajax-address--active');
        let successText = findIn('.js-ajax-address__text', activeAddress);
        const pristine = createFormValidation(modalForm);

        modalForm.addEventListener('submit', function (e) {
            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            e.preventDefault();

            if (!pristine.validate()){
                //console.log('not valid')
            } else {
                let formData = formDataEntries(modalForm);
                let params = new URLSearchParams(formData);
                let url = modalForm.getAttribute('data-action') || throwError(translate('login.no.action.url'))

                removeAttribute('hidden', loading);

                pendingRequest = fetch(url, {
                    method: 'POST',
                    body: params,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                    },
                    dataType: 'JSON'
                });
                pendingRequest
                    .then((response) => {
                        return response.clone().json()
                    }).then((response) => {

                    if (!response.error) {
                        /* hide modal */
                        let editModalEl = document.getElementById('editAdress');
                        let editModal = Modal.getInstance(editModalEl);
                        editModal.hide();

                        if (response.delete) {
                            activeAddress.remove();
                        } else {
                            /* set response */
                            let html = response.html || throwError(translate('no.html.given'))
                            successText.innerHTML = html;
                            setAttribute('hidden', true, loading);
                        }
                    }
                }).catch((error) => {
                    if (error.name !== 'AbortError') {
                        /*Do error stuff*/
                        console.error(error);
                    }
                    setAttribute('hidden', true, loading);
                });
                showNotification(pendingRequest);
            }
        });
    }

}